import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCi4TykP7Ebnq-gwkKaDWwceR_bdsCDROE",
  authDomain: "stuttgart-stage2-staging.firebaseapp.com",
  projectId: "stuttgart-stage2-staging",
  storageBucket: "stuttgart-stage2-staging.firebasestorage.app",
  messagingSenderId: "200440653757",
  appId: "1:200440653757:web:b268873f0c9b8f0b3854d4"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);

const useEmulators = process.env.REACT_APP_USE_EMULATORS === "1";

if (useEmulators) {
  console.log("🔥 Using Firebase EMULATORS");
  connectFirestoreEmulator(db, "127.0.0.1", 8085);
  connectAuthEmulator(auth, "http://127.0.0.1:9095");
} else {
  console.log("✅ Using LIVE Firebase");
}